import { schema } from 'normalizr';

import type { PrintPageViewerData } from '@frontend/api';

import { normalizePartFileForViewer, type ViewerPartFile } from '../types';

export const printPageSchema = new schema.Entity<PrintPageViewerData>(
  'printPages',
  {},
);

export const partFileSchema = new schema.Entity<ViewerPartFile>(
  'partFiles',
  {
    printPages: [printPageSchema],
  },
  {
    idAttribute: 'uuid',
    processStrategy: normalizePartFileForViewer,
  },
);
